export enum BlockItemType {
    image,
    social,
    product,
    promo,
    bundle,
    category,
    why,
    content,
    seemore,
    empty,
}